import { DecorationSet } from "@tiptap/pm/view";

import {
  createLatexDecorations,
  findLatexMarkersInTextNodes,
  findLatexPairs,
  getLatexMathParser,
  shouldExcludeNodeFromLatexConversion,
} from "./utils";

import type { Node as ProseMirrorNode } from "@tiptap/pm/model";
import type { Decoration } from "@tiptap/pm/view";

/**
 * Scan document on init and create decorations for all $...$ and $$...$$ patterns
 * Returns DecorationSet for invalid LaTeX (valid ones will be converted)
 */
export function scanDocumentForLatex(doc: ProseMirrorNode): DecorationSet {
  const allDecorations: Decoration[] = [];

  // Scan entire document for text blocks
  doc.descendants((node: ProseMirrorNode, pos: number) => {
    if (shouldExcludeNodeFromLatexConversion(node)) return;

    const parseMathLatex = getLatexMathParser();

    if (!parseMathLatex) return;

    const blockStart = pos + 1;
    const blockEnd = pos + 1 + node.content.size;

    const markers = findLatexMarkersInTextNodes(node, blockStart);
    const pairs = findLatexPairs(markers, doc, blockEnd, blockEnd);

    for (const pair of pairs) {
      const { content, end } = pair;

      if (!end || !content.trim()) continue;

      let hasError = false;
      try {
        parseMathLatex(content);
      } catch {
        hasError = true;
      }

      if (hasError) {
        allDecorations.push(
          ...createLatexDecorations({
            pair,
            isCursorInside: false,
            hasError: true,
          }),
        );
      }
    }
  });

  return DecorationSet.create(doc, allDecorations);
}
